import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex) //使用Vue的插件引入函数Vue.use()使用Vuex

import order from './order';

// 安装之后可以通过Vuex实例对象的Store方法创建一个store对象：
window.store = new Vuex.Store({
    modules : {
        order,
    },
	// module：将 store 分割成模块（module）。每个模块拥有自己的 
	// state、mutation、action、getter、甚至是嵌套子模块——
	// 从上至下进行同样方式的分割
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js